import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import SectionHeader from "../SectionHeader";
import { competitions } from "../../../../content/competitions";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm.competitions";

export default function CompetitionsSection() {
  const { t } = useTranslation();
  const [active, setActive] = useState(competitions[0].slug);
  const current = competitions.find((c) => c.slug === active) || competitions[0];

  return (
    <section className={style.competitions} id="historico-de-concursos">
      <SectionHeader
        label={t(`${keyI18n}.label`)}
        title={t(`${keyI18n}.title`)}
      />

      <div className={style.tabs} role="tablist">
        {competitions.map(({ slug, label }) => (
          <button
            aria-controls={`competition-${slug}`}
            aria-selected={slug === active}
            className={[
              "pgm-title-small",
              style.tab,
              slug === active ? style.tabActive : "",
            ]
              .filter(Boolean)
              .join(" ")}
            id={`tab-${slug}`}
            key={slug}
            onClick={() => setActive(slug)}
            role="tab"
            type="button"
          >
            {label}
          </button>
        ))}
      </div>

      <div
        aria-labelledby={`tab-${current.slug}`}
        className={style.panel}
        id={`competition-${current.slug}`}
        role="tabpanel"
      >
        <p className={`pgm-label-large ${style.caption}`}>{current.caption}</p>

        <div className={style.tableWrapper}>
          <table className={style.table}>
            <thead>
              <tr>
                <th className="pgm-title-small" scope="col">{t(`${keyI18n}.columns.act`)}</th>
                <th className={`pgm-title-small ${style.dateCol}`} scope="col">
                  {t(`${keyI18n}.columns.signature`)}
                </th>
                <th className={`pgm-title-small ${style.dateCol}`} scope="col">
                  {t(`${keyI18n}.columns.publication`)}
                </th>
              </tr>
            </thead>
            <tbody>
              {current.rows.map((row, index) => (
                <tr key={`${row.act}-${index}`}>
                  <th className="pgm-body-medium" scope="row">{row.act}</th>
                  <td className={`pgm-body-medium ${style.dateCol}`}>{row.signature}</td>
                  <td className={`pgm-body-medium ${style.dateCol}`}>{row.publication}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
